import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ControlSelect, ControlText } from "../../../common/custom-form/control-field.component";
import { pipInformationActions } from "../../../../store/external/inventory/details-view/pip-information.reducer";
import { REQUEST_TYPES_ID } from "../../../../constants/external-constants";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import { isDisabledPerRequestType } from '../../../../utils/helpers.utils';
import CustomSearchableDropdownWrapper from "../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
class PIPInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDropdown: false,
        }
    }  

    componentDidMount() {
        const { fetchPipData, circuitOrderPipForm } = this.props;
        if (typeof fetchPipData === 'function') {
            fetchPipData(circuitOrderPipForm)
        }
    }

    searchableChange(event, model) {
        this.props.changeFormModel(model, event.key);
    }

    toggleActiveState = () => {
        const { isCircuitOrder, requestTypeId } = this.props;
        const noAddFunction = (isCircuitOrder && (parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.subscriptionCancellation))) || (parseInt(requestTypeId) === parseInt(REQUEST_TYPES_ID.portOut));

        if (isCircuitOrder && this.hasExistingSimList() && noAddFunction) {
            this.setState({ activeDropdown: false });
        }
        else {
            this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    modelValue = (key, isString = true) => {
        const { inventoryCircuitForm, circuitOrderPipForm, isInventoryCircuit } = this.props;

        const pipInfo = inventoryCircuitForm?.pipInformation || {};  
        const value = isInventoryCircuit ? pipInfo[key] : circuitOrderPipForm?.[key];

        if (value === null || value === undefined) {
            return isString ? "" : null;
        }

        return value;
    };
    handlePortSpeedSearch = (query) => {
        this.props.getPIPPortSpeed(1, query);
    }

    loadMorePortSpeed = (searchString) => {
        const { portSpeedPage } = this.props;
        this.props.getPIPPortSpeed(portSpeedPage + 1, searchString);
    }
    handleCarrierQosProfileSearch = (query) => {
        this.props.getPIPCarrierQosProfile(1, query);
    }

    loadMoreCarrierQosProfile = (searchString) => {
        const { carrierQOSProfilePage } = this.props;
        this.props.getPIPCarrierQosProfile(carrierQOSProfilePage + 1, searchString);
    }
    handleVpnNameSearch = (query) => {
        this.props.getPIPVpnName(1, query);
    }

    loadMoreVpnName = (searchString) => {
        const { vpnNamePage } = this.props;
        this.props.getPIPVpnName(vpnNamePage + 1, searchString);
    }
    handleVoiceCarSpeedSearch = (query) => {
        this.props.getPIPVoiceCarSpeed(1, query);
    }

    loadMoreVoiceCarSpeed = (searchString) => {
        const { voiceCarSpeedPage } = this.props;
        this.props.getPIPVoiceCarSpeed(voiceCarSpeedPage + 1, searchString);
    }
    handleSiteOfOriginSearch = (query) => {
        this.props.getPIPSiteOfOrigin(1, query);
    }

    loadMoreSiteOfOrigin = (searchString) => {
        const { siteOfOriginPage } = this.props;
        this.props.getPIPSiteOfOrigin(siteOfOriginPage + 1, searchString);
    }
    handleVoiceCarSearch = (query) => {
        this.props.getPIPVoiceCar(query);
    }
        
    render() {
        const {
            portSpeedOptions,
            carrierQosProfileOptions,
            voiceCarOptions,
            vpnNameOptions,
            voiceCarSpeedOptions,
            asnNewOrExistingOptions,
            siteOfOriginOptions,
            requestTypeId,
            formModel,
            completed,
            isPortSpeedLoading,
            hasMorePortSpeed,
            isCarrierQOSProfileLoading,
            hasMoreCarrierQOSProfile,
            isVpnNameLoading,
            hasMoreVpnName,
            isVoiceCarSpeedLoading,
            hasMoreVoiceCarSpeed,
            isVoiceCarLoading,
            hasMoreVoiceCar,
            isSiteOfOriginLoading,
            hasMoreSiteOfOrigin,
            formName,
            isInventoryCircuit } = this.props;

        return (
            <CustomDropdown label={`${this.toLocaleLanguage('pip_information')}`} activeDropdown={this.state.activeDropdown} toggleActiveState={this.toggleActiveState} >
                <div className="details-4-col-container address-detail-container add-sim-container">
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('port_speed_caps')}`}
                        options={portSpeedOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.pipInformation?.portSpeed ?? "") : (this.props[formModel].portSpeed ?? "")} 
                        onChange={(e) => this.searchableChange(e, `${formModel}.portSpeed`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.portSpeed`}
                        tagName="portSpeed"
                        optionLabelKey={{
                            Key: "FilterId",
                            Value: "FilterName"
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, "portSpeed")}
                        onSearchChange={this.handlePortSpeedSearch}
                        onLoadMore={this.loadMorePortSpeed}
                        isLoading={isPortSpeedLoading}
                        hasMore={hasMorePortSpeed}
                    />
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('carrier_qos_profile_caps')}`}
                        options={carrierQosProfileOptions}
                        selected={isInventoryCircuit ? this.props[formName]?.pipInformation?.carrierQOSProfile ?? "" : (this.props[formModel].carrierQOSProfile ?? "")}
                        onChange={(e) => this.searchableChange(e, `${formModel}.carrierQOSProfile`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.carrierQOSProfile`}
                        tagName='carrierQOSProfile'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'carrierQOSProfile')}
                        onSearchChange={this.handleCarrierQosProfileSearch}
                        onLoadMore={this.loadMoreCarrierQosProfile}
                        isLoading={isCarrierQOSProfileLoading}
                        hasMore={hasMoreCarrierQOSProfile}
                    />
                    <ControlText
                        model={`${formModel}.asnNumber`}
                        label={`${this.toLocaleLanguage('asn_number_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        value={`${this.modelValue('asnNumber', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'asnNumber')}
                    /> 
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('voice_car_caps')}`}
                        options={voiceCarOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.pipInformation?.voiceCAR ?? "") : (this.props[formModel].voiceCAR ?? "")}
                        onChange={(e) => this.searchableChange(e, `${formModel}.voiceCAR`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.voiceCAR`}
                        tagName='voiceCAR'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'voiceCAR')}
                        onSearchChange={this.handleVoiceCarSearch}
                        isLoading={isVoiceCarLoading}
                        hasMore={hasMoreVoiceCar}
                    />
                    <ControlText
                        model={`${formModel}.routingProtocol`}
                        label={`${this.toLocaleLanguage('routing_protocol_caps')}`}
                        placeholder="Enter text here..."
                        className="form-control"
                        customClass="remove-left__indent"
                        value={`${this.modelValue('routingProtocol', true)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'routingProtocol')}
                    /> 
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('vpn_name_caps')}`}
                        options={vpnNameOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.pipInformation?.vpnName ?? "") : (this.props[formModel].vpnName ?? "")}
                        onChange={(e) => this.searchableChange(e, `${formModel}.vpnName`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.vpnName`}
                        tagName='vpnName'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'vpnName')}
                        onSearchChange={this.handleVpnNameSearch}
                        onLoadMore={this.loadMoreVpnName}
                        isLoading={isVpnNameLoading}
                        hasMore={hasMoreVpnName}
                    />
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('voice_car_speed_caps')}`}
                        options={voiceCarSpeedOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.pipInformation?.voiceCARSpeed ?? "") : (this.props[formModel].voiceCARSpeed ?? "")}
                        onChange={(e) => this.searchableChange(e, `${formModel}.voiceCARSpeed`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.voiceCARSpeed`}
                        tagName='voiceCARSpeed'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'voiceCARSpeed')}
                        onSearchChange={this.handleVoiceCarSpeedSearch}
                        onLoadMore={this.loadMoreVoiceCarSpeed}
                        isLoading={isVoiceCarSpeedLoading}
                        hasMore={hasMoreVoiceCarSpeed}
                    />
                    <ControlSelect
                        model={`${formModel}.asnNewOrExisting`}
                        label={`${this.toLocaleLanguage('asn_new_or_existing_caps')}`}
                        placeholder="Select..."
                        options={asnNewOrExistingOptions}
                        className="form-select"
                        value={`${this.modelValue('asnNewOrExisting', false)}`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'asnNewOrExisting')} /> 
                    <CustomSearchableDropdownWrapper
                        label={`${this.toLocaleLanguage('site_of_origin_caps')}`}
                        options={siteOfOriginOptions}
                        selected={isInventoryCircuit ? (this.props[formName]?.pipInformation?.siteOfOrigin ?? "") : (this.props[formModel].siteOfOrigin ?? "")}
                        onChange={(e) => this.searchableChange(e, `${formModel}.siteOfOrigin`)}
                        placeholder="Select..."
                        fieldProp={`${formModel}.siteOfOrigin`}
                        tagName='siteOfOrigin'
                        optionLabelKey={{
                            Key: 'FilterId',
                            Value: 'FilterName'
                        }}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'siteOfOrigin')}
                        onSearchChange={this.handleSiteOfOriginSearch}
                        onLoadMore={this.loadMoreSiteOfOrigin}
                        isLoading={isSiteOfOriginLoading}
                        hasMore={hasMoreSiteOfOrigin}
                    />
                </div>
            </CustomDropdown>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuitPIPInformation, circuitOrderPIPInformation, translation } = state;
        const { inventoryCircuitForm, circuitOrderForm, circuitOrderPipForm } = state.form;
        return {
            ...inventoryCircuitPIPInformation,
            ...circuitOrderPIPInformation,
            ...translation,
            inventoryCircuitForm,
            circuitOrderForm,
            circuitOrderPipForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, pipInformationActions),
        dispatch
    )
)(PIPInformation)